<template>
  <div id="app">
    <Page />
  </div>
</template>

<script>
import Page from './page';
export default {
  name: 'App',
  components:{
    Page
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
